import React, { FC, useContext, useMemo, useRef } from 'react';
import { commonClassName } from './PromoScorecard';
import TableErrorBox from 'components/molecules/ErrorBox/TableErrorBox';
import InfiniteScroller from 'components/molecules/InfiniteScroller';
import { useFillHeightToFitScreen } from 'hooks/general/useFillHeightToFitScreen';
import { promoRecommendationPlansTableColumns } from 'utils/getRecommendationTableColumns';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { CustomTable } from 'components/template/PricingSimulator/PricingSimulatorIndexTableWrapper';
type Props = {
    planData: any;
    planLoading: boolean;
    planError: any;
    setSelectedPlan: Function;
};

const plansTableId = 'plans-index-table';

const PromoRecommendationContainer: FC<Props> = ({ planData, planLoading, planError, setSelectedPlan }) => {
    const { appConfig: config } = useContext(UserContext);
    const promoRecommendationConfig = getConfig('promoRecommendation', config);
    const { plansIndexTableColumns = [] } = promoRecommendationConfig;
    const mainSectionHeight = useRef<number | null>(0);

    //table columns
    const memoisedColumns = useMemo(() => {
        if (!planData) return [];

        return promoRecommendationPlansTableColumns(
            plansIndexTableColumns,

            {
                sortBy: 0,
                sortOrder: null,
            },
            setSelectedPlan,
        );
    }, [planData]);
    //this hook with give height to fill the screen height
    mainSectionHeight.current = useFillHeightToFitScreen({
        id: plansTableId,
        triggerDummyRender: true,
        height: mainSectionHeight.current,
        buffer: 90, //footer
    });

    return (
        <section className={`mb-2 bg-white `}>
            <InfiniteScroller
                data={planData}
                loading={planLoading}
                hasMore={planLoading}
                height={
                    planData && !planError
                        ? mainSectionHeight.current ?? undefined
                        : isNaN(Number(mainSectionHeight.current))
                        ? undefined
                        : Number(mainSectionHeight.current) - 1 //there should be a change in height when its loading and not loading, thats the reason for subtracting 1
                }
                //height={200}
                //     loader={true}
                onNext={() => {}}
            >
                <CustomTable
                    sticky={{
                        getContainer: () =>
                            document.getElementsByClassName('infinite-scroll-component')?.[0] as HTMLElement,
                    }} //adding x axis scrollbar on table
                    id={plansTableId}
                    //loading={planLoading}
                    columns={memoisedColumns}
                    scroll={{ x: '100%' }}
                    dataSource={planData}
                    pagination={false}
                    style={{
                        opacity: planLoading ? '0.3' : 1,
                        pointerEvents: planLoading ? 'none' : 'auto',
                    }}
                    locale={{
                        emptyText: planLoading ? (
                            <></>
                        ) : planError ? (
                            <TableErrorBox error={planError} height={mainSectionHeight.current} />
                        ) : (
                            ''
                        ),
                    }}
                />
            </InfiniteScroller>
        </section>
    );
};

export default PromoRecommendationContainer;
